import * as _ from 'lodash';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { InvoiceModel } from '@app/core/models/invoices/invoice.model';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { InvoiceService } from '../../services/invoice.service';
import { InvoiceViewType } from '@app/core/models/invoices/invoice-view-type.model';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { AuthenticationInfoService } from '@app/core/guards/authentication-info.service';

@Injectable({ providedIn: 'root' })
export class InvoicesResolver  {
  constructor(
    private invoiceService: InvoiceService,
    private authenticationInfoService: AuthenticationInfoService,
    private sessionStorageService: SessionStorageService) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<InvoiceModel[]> | Promise<InvoiceModel[]> | InvoiceModel[] {
    if (state.url.includes(InvoiceViewType.DISPATCHED)) {
      return this.invoiceService.getDispatchedInvoices().pipe(catchError(this.handleError));
    }

    const searchFilterKey = route.data.searchFilterKey;
    const searchFilter = this.sessionStorageService.get<any>(searchFilterKey);

    if (state.url.includes(InvoiceViewType.REJECTED)) {
      if (_.isNil(searchFilter) || _.isNil(searchFilter.SelectedGroups)) {
        return this.invoiceService.getRejectedInvoices(this.authenticationInfoService.authentificatedUser.GroupsMembership.SupervisionGroups).pipe(catchError(this.handleError));
      } else {
        return this.invoiceService.getRejectedInvoices(searchFilter.SelectedGroups.map(g => g.Id)).pipe(catchError(this.handleError));
      }
    }

    if (state.url.includes(InvoiceViewType.VOUCHERVALIDATED)) {
      if (_.isNil(searchFilter) || _.isNil(searchFilter.SelectedGroups)) {
        return this.invoiceService.getApprovedVouchers(this.authenticationInfoService.authentificatedUser.GroupsMembership.NonERPComptabilityGroups).pipe(catchError(this.handleError));
      } else {
        return this.invoiceService.getApprovedVouchers(searchFilter.SelectedGroups.map(g => g.Id)).pipe(catchError(this.handleError));
      }
    }

    if (state.url.includes(InvoiceViewType.CONTROL)) {
      return this.invoiceService.getUncheckedInvoices().pipe(catchError(this.handleError));
    }

    if (state.url.includes(InvoiceViewType.VOUCHERWORKFLOW)) {
      return this.invoiceService.getProcessedInvoices().pipe(catchError(this.handleError));
    }

    // Ajout des factures à valider Promotion
    if (state.url.includes(InvoiceViewType.PROMOTIONWORKFLOW)) {
      return this.invoiceService.getProcessedPromotionInvoices().pipe(catchError(this.handleError));
    }

    if (state.url.includes(InvoiceViewType.WAITING)) {
      return this.invoiceService.getWaitingInvoices().pipe(catchError(this.handleError));
    }

    throwError(new Error('Not implemented !'));
  }

  private handleError(err: HttpErrorResponse | any) {
    console.error('An error occurred', err);
    return throwError(err.message || err);
  }
}
